// TO DEFINE THE STATES AND CHANGE STATUS
import { createSlice } from '@reduxjs/toolkit';
import {
  fetchDailyTickets,
  fetchDailyTicketsByPeriod,
  updateDailyTicket,
  fetchDailyTicketByDate,
  updateDailyTicketNotesThunk,
} from './dailyTicketsThunks';
import { subscribeToDailyTicketById } from './dailyTicketsService';

const initialState = {
  dailyTickets: [],
  dailyTicketsByPeriod: [],
  selectedDailyTicket: null,
  status: 'idle',
  error: null,
};

const dailyTicketsSlice = createSlice({
  name: 'dailyTickets',
  initialState,
  reducers: {
    setDailyTicketsFromSnapshot: (state, action) => {
      state.dailyTickets = action.payload;
      state.status = 'succeeded';
    },
    setSelectedDailyTicketFromSnapshot: (state, action) => {
      state.selectedDailyTicket = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyTickets.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchDailyTickets.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.dailyTickets = action.payload;
        state.error = null;
      })
      .addCase(fetchDailyTickets.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchDailyTicketByDate.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchDailyTicketByDate.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.selectedDailyTicket = action.payload;
        state.error = null;
      })
      .addCase(fetchDailyTicketByDate.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchDailyTicketsByPeriod.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchDailyTicketsByPeriod.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.dailyTicketsByPeriod = action.payload;
        state.error = null;
      })
      .addCase(fetchDailyTicketsByPeriod.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(updateDailyTicket.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateDailyTicket.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.dailyTickets = action.payload;
        state.error = null;
      })
      .addCase(updateDailyTicket.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(updateDailyTicketNotesThunk.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateDailyTicketNotesThunk.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.selectedDailyTicket = action.payload;
        state.error = null;
      })
      .addCase(updateDailyTicketNotesThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { setDailyTicketsFromSnapshot, setSelectedDailyTicketFromSnapshot } = dailyTicketsSlice.actions;

export const selectDailyTickets = (state) => state.dailyTickets.dailyTickets;
export const selectDailyTicketsByPeriod = (state) => state.dailyTickets.dailyTicketsByPeriod;
export const selectDailyTicketsStatus = (state) => state.dailyTickets.status;
export const selectDailyTicketsError = (state) => state.dailyTickets.error;
export const selectSelectedDailyTicket = (state) => state.dailyTickets.selectedDailyTicket;

// Real time listener for a single daily ticket by document ID
const createDailyTicketListener = () => {
  let unsubscribe = null;
  return {
    start: (ticketId, dispatch) => {
      if (unsubscribe) unsubscribe();
      unsubscribe = subscribeToDailyTicketById(ticketId, (ticket) => {
        dispatch(setSelectedDailyTicketFromSnapshot(ticket));
      });
    },
    stop: () => {
      if (unsubscribe) unsubscribe();
      unsubscribe = null;
    },
  };
};

const dailyTicketListener = createDailyTicketListener();

export const startDailyTicketListener = (ticketId) => (dispatch) => {
  dailyTicketListener.start(ticketId, dispatch);
};

export const stopDailyTicketListener = () => (dispatch) => {
  dailyTicketListener.stop();
};

export default dailyTicketsSlice.reducer;
